<script setup lang="ts">
import { CircleAlert } from "@lucide/vue";
import { computed } from "vue";
import { isProblem } from "@/api/client";
import { t } from "@/copy/strings";

/** Inline error under a form: problem detail plus field issues. */
const props = defineProps<{ error: unknown }>();

const message = computed(() => {
  const err = props.error;
  if (!err) return null;
  if (isProblem(err)) {
    if (err.status === 0) return t.errors.network;
    if (err.notAvailable) return t.errors.notAvailableBody;
    return err.detail ?? err.title;
  }
  return (err as Error)?.message ?? t.errors.generic;
});
const issues = computed(() => (isProblem(props.error) ? props.error.issues : []));
</script>

<template>
  <div v-if="message" role="alert" class="flex gap-2 rounded-md border border-destructive/30 bg-destructive-soft px-3 py-2 text-sm text-destructive">
    <CircleAlert class="mt-0.5 size-4 shrink-0" aria-hidden="true" />
    <div class="min-w-0">
      <p class="font-medium">{{ message }}</p>
      <ul v-if="issues.length" class="mt-1 list-disc pl-4 text-xs">
        <li v-for="issue in issues" :key="issue.path + issue.message">
          <code v-if="issue.path">{{ issue.path }}</code> {{ issue.message }}
        </li>
      </ul>
    </div>
  </div>
</template>
